import React from 'react';
import { useSelector } from 'react-redux';

const DesktopTitle = () => {
  const { collectionTotal } = useSelector((state) => state.properties);
  const { desktopDevice } = useSelector((state) => state.viewportSlice);

  if (!desktopDevice) return null;

  return (
    <>
      <div className='typo-subtitle vesta-indigo-100'>
        <span className='typo-h3 vesta-blue-100'>{collectionTotal}</span> bien{collectionTotal > 1 && 's'} trouvé{collectionTotal > 1 && 's'}
      </div>
    </>
  )
};

export default DesktopTitle;
